export default {
      id: "heart2-usage",
      viewBox: "0 0 512 445",
      url: __webpack_public_path__ + "img/svg-sprite.svg#heart2",
      toString: function () {
        return this.url;
      }
    }